import { render, staticRenderFns } from "./confirm-reciept.vue?vue&type=template&id=7cbe40ca"
import script from "./confirm-reciept.vue?vue&type=script&lang=js"
export * from "./confirm-reciept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports